import { render } from "./actionTaskEdit.vue?vue&type=template&id=a82963a6&scoped=true&ts=true"
import script from "./actionTaskEdit.vue?vue&type=script&lang=ts"
export * from "./actionTaskEdit.vue?vue&type=script&lang=ts"

import "./actionTaskEdit.vue?vue&type=style&index=0&id=a82963a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a82963a6"]])

export default __exports__